export const GUEST_SESSION_STORAGE_KEY = 'edify-session-guest'
